import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ParentsService } from '../../serivce/parents.service';

@Component({
  selector: 'app-parent-delete-dialog',
  templateUrl: './parent-delete-dialog.component.html',
  styleUrls: ['./parent-delete-dialog.component.css']
})
export class ParentDeleteDialogComponent implements OnInit {
  datas: any;
  constructor(private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    private parentService: ParentsService,
  ) {
    this.datas = data;
  }

  ngOnInit() {
  }
  delParents() {
    debugger
    var models = {
      id : this.datas.model.id
    }
    this.spinner.show();
    this.parentService.delParents(models).subscribe(res => {
      this.spinner.hide();
      if (res.status == 2) {
        this.toastr.success(res.content, "Thành công");
        this.dialogRef.close();
      }
      else {
        this.toastr.error(res.content, "Thất bại");
      }
    })
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
